import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangeCredentials() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [newEmail, setNewEmail] = useState(user?.email || "");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirm) return setError("Le password non coincidono");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-credentials", {
        new_email: newEmail,
        new_password: newPassword,
        current_password: currentPassword,
      });
      login(data.token, data.user);
      toast.success("Credenziali aggiornate");
      navigate("/");
    } catch (err) {
      setError(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-100">
            <ShieldCheck className="text-indigo-600" size={28} />
          </div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Imposta le tue credenziali</h1>
          <p className="mt-1 text-sm text-slate-500">Per sicurezza, al primo accesso devi impostare email e password personali.</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl border border-slate-200 bg-white p-7 shadow-sm space-y-4">
          <div className="space-y-1.5">
            <Label>Nuova email</Label>
            <Input data-testid="input-new-email" type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label>Password attuale (temporanea)</Label>
            <Input data-testid="input-current-password" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label>Nuova password</Label>
            <Input data-testid="input-new-password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength={6} />
          </div>
          <div className="space-y-1.5">
            <Label>Conferma nuova password</Label>
            <Input data-testid="input-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </div>
          {error && <p data-testid="setup-error" className="text-sm text-red-500">{error}</p>}
          <Button data-testid="btn-save-credentials" type="submit" disabled={loading} className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 font-semibold">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Salva e continua"}
          </Button>
        </form>
      </div>
    </div>
  );
}
